module.exports = __webpack_public_path__ + "img/dashboard-truck-ongoing.e1a4a342.svg";